export default __webpack_public_path__ + "locales/fr/EmptyView.json?hash=4f4fd6d29a400a70861138884df246ab";